<template>
    <div>
        <h6 class="mdc-list-group__subheader t-body4">
            {{$t('228')}}
            <!-- 강의 목록 -->
        </h6>
        <router-link class="mdc-list-item" to="/degree?type=ListTotal" :tabindex="menuActive === 'ListTotal' || !token ? 0 : -1">
            <i class="material-icons mdc-list-item__graphic">inbox</i>
            {{$t('229')}}
            <!-- <span class="material-icons">folder</span>
            {{$t('S10000')}} -->
            <!-- 추천 강의 -->
        </router-link>
        <router-link class="mdc-list-item" to="/degree?type=ListPopular" :tabindex="menuActive === 'ListPopular' ? 0 : -1">
            <i class="material-icons mdc-list-item__graphic">inbox</i>
            {{$t('230')}}
            <!-- 인기 강의 -->
        </router-link>
        <router-link class="mdc-list-item" to="/degree?type=ListNew" :tabindex="menuActive === 'ListNew' ? 0 : -1">
            <i class="material-icons mdc-list-item__graphic">inbox</i>
            {{$t('231')}}
            <!-- 신규 강의 -->
        </router-link>
    </div>
</template>

<script>
/**
 * 네비게이션 드로워 전체 강의 컴포넌트(navigation drawer degree menu Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    data() {
        return {
            token: localStorage.getItem('token'),
            menuActive: ''
        }
    },

    watch:{
        '$route' (to, from){
            this.menuActive = to.query.type
        }
    },
}
</script>